import { axiosInstance } from 'utils/http';
import { question } from 'utils/urlConstants';
import { showAlert } from 'redux/actions/AlertActions';
import { useDispatch, useSelector } from 'react-redux';
import { useMutation } from 'react-query';


export const useDeleteSchemaColumns = () => {
  const dispatch = useDispatch();
  const orgId = useSelector(state => state.session.user.primaryOrganization.organization.ID);

  return useMutation(
    (payload) => axiosInstance.post(
      question(orgId).deleteSchemaColumns(payload.cleanRoomID, payload.questionID), payload,
    ),
    {
      onSuccess: () => { },
      onError: (err) => {
        dispatch(showAlert({
          message: err?.response?.data?.message
            || 'Error while deleting schema columns.',
          type: 'error',
        }));
      },
    },
  );
};
